import { render, staticRenderFns } from "./MappingManagement.vue?vue&type=template&id=304d6477&scoped=true"
import script from "./MappingManagement.vue?vue&type=script&lang=js"
export * from "./MappingManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304d6477",
  null
  
)

export default component.exports